import { render, staticRenderFns } from "./serviceProjectListOld.vue?vue&type=template&id=780c78dc&scoped=true&"
import script from "./serviceProjectListOld.vue?vue&type=script&lang=js&"
export * from "./serviceProjectListOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c78dc",
  null
  
)

component.options.__file = "serviceProjectListOld.vue"
export default component.exports